export const METHOD_BALANCE_OF = 'balanceOf';
export const METHOD_TRANSFER = 'transfer';
export const METHOD_STAKE = 'stake'; // 위임
export const METHOD_UPDATE_REWARD = 'updateReward';
export const METHOD_ADD_REWARD_PERIOD = 'addRewardPeriod';
export const METHOD_CLAIM_REWARD = 'claimReward'; // 리워드 보상
export const METHOD_GET_INDIVIDUAL_REWARD = 'getIndividualReward';
export const METHOD_GET_TOTAL_REWARDS = 'getTotalRewards'; // 동일 지갑의 전체 보상을 조회합니다.
// 풀 설정관련 함수
export const METHOD_SET_POOL_NAME = 'setPoolName'; // 풀 이름
export const METHOD_SET_POOL_DESCRIPTION = 'setPoolDescription'; // 풀 설명
export const METHOD_STARTFUNDRAISING = 'startFundraising'; // 상태를 '모금 기간'으로 변경
// 모금 대기 상태에서만 설정 가능
export const METHOD_SETMINSTAKEAMOUNT = 'setMinStakeAmount'; // 최소 스테이킹 금액 (달러 기준)
export const METHOD_SET_INTEREST_RATE = 'setInterestRate'; // 이자율
export const METHOD_SET_FUNDRAISING_DURATION = 'setFundraisingDuration'; // 모금 기간
export const METHOD_SET_OPERATING_DURATION = 'setOperatingDuration'; // 운영 기간
export const METHOD_SET_MIN_FUNDRAISING_AMOUNT = 'setMinFundraisingAmount'; // 최소 모금 금액
export const METHOD_SET_MAX_FUNDRAISING_AMOUNT = 'setMaxFundraisingAmount'; // 최대 모금 금액
export const METHOD_SET_STAKING_TOKEN = 'setStakingToken'; // 스테이킹 대상 토큰 주소
// 모금 기간 관련 함수들
export const METHOD_STOP_FUNDRAISING = 'stopFundraising'; // 모금 중지 로직
export const METHOD_UNSTAKE_SFL = 'unstakeSFL';
export const METHOD_WITHDRAW_FAILED_FUNDRAISING = 'withdrawFailedFundraising'; // 모금 실패 시 자금 회수 로직
// 운영 기간 관련 함수들
export const METHOD_STOP_OPERATING = 'stopOperating'; // 운영 중지 로직
export const METHOD_VIEW_REWARDS = 'viewRewards'; // 보상 조회 로직
export const METHOD_VIEW_ACCUMULATED_REWARDS = 'viewAccumulatedRewards'; // 누적 보상 조회 로직
export const METHOD_REQUEST_REWARDS = 'requestRewards'; // 보상 요청 로직
export const METHOD_WITHDRAW_AT_CLOSURE = 'withdrawAtClosure'; // 운영 종료 시 자금 회수 로직
// 상태 변경 함수들
export const METHOD_START_OPERATING = 'startOperating'; // 상태를 '운영 기간'으로 변경하는 로직
export const METHOD_CLOSE_POOL = 'closePool'; // 스테이킹 풀을 종료하는 로직
